"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomerRedirectUrlStatuses = exports.customerRedirectUrlHandler = void 0;
const logger_1 = require("./logger");
function customerRedirectUrlHandler(customerRedirectUrl, roomSid, reservationSid, statusCode) {
    const defaultRedirectUrl = 'https://www.streem.com';
    if (!customerRedirectUrl) {
        window.location.replace(defaultRedirectUrl);
        return;
    }
    try {
        const redirectUrl = new URL(customerRedirectUrl);
        if (roomSid)
            redirectUrl.searchParams.set('roomId', roomSid);
        if (reservationSid)
            redirectUrl.searchParams.set('reservationId', reservationSid);
        if (statusCode)
            redirectUrl.searchParams.set('statusCode', statusCode);
        window.location.replace(redirectUrl.toString());
    }
    catch (e) {
        logger_1.logger.error('Invalid redirect URL passed to constructor', e);
        window.location.replace(defaultRedirectUrl.toString());
    }
}
exports.customerRedirectUrlHandler = customerRedirectUrlHandler;
var CustomerRedirectUrlStatuses;
(function (CustomerRedirectUrlStatuses) {
    CustomerRedirectUrlStatuses["OK"] = "OK";
    CustomerRedirectUrlStatuses["LOGIN_ERROR"] = "LOGIN_ERROR";
    CustomerRedirectUrlStatuses["BAD_REQUEST"] = "BAD_REQUEST";
    CustomerRedirectUrlStatuses["DECLINED_TCS"] = "DECLINED_TCS";
    CustomerRedirectUrlStatuses["CALL_RESTART_FAILED"] = "CALL_RESTART_FAILED";
    CustomerRedirectUrlStatuses["CALL_REJECTED"] = "CALL_REJECTED";
    CustomerRedirectUrlStatuses["CALL_TIMED_OUT"] = "CALL_TIMED_OUT";
    CustomerRedirectUrlStatuses["CALL_CANCELED"] = "CALL_CANCELED";
    CustomerRedirectUrlStatuses["GROUP_RESERVATION_EXPIRED"] = "GROUP_RESERVATION_EXPIRED";
})(CustomerRedirectUrlStatuses = exports.CustomerRedirectUrlStatuses || (exports.CustomerRedirectUrlStatuses = {}));
//# sourceMappingURL=redirect_helpers.js.map